<template>
  <h4>Electronic Business Consent</h4>
  <div class="disclaimer-modal">
    <strong>CONSENT TO CONDUCT BUSINESS ELECTRONICALLY</strong>
    <p></p>
    <p>
      <strong
        >Please print or download a copy of this Disclosure for your
        records</strong
      >
    </p>
    <p>
      We are required by law to obtain Your consent to enter into the Contract
      and deliver Communications to You electronically. This Disclosure applies
      to all Communications related to Your Renters policy.&nbsp; The
      “<strong>We</strong>,” “<strong>Us</strong>,” and “<strong>Our</strong>”
      refer to the company that issues Your Contract or provides evidence of
      coverage to You, and all of its subsidiaries, affiliates and agents.
      companies operate under the trade name, Assurant. The words
      “<strong>You</strong>” and “<strong>Your</strong>” mean You, the
      individual(s) or entity that owns the Contract or an authorized
      representative.
      <strong
        >Your consent to this Disclosure is not required to obtain or renew any
        product or service provided by Us.</strong
      >
    </p>
    <p>
      “<strong>Communications</strong>” means all information that We are
      required to provide You by law, or as reasonably necessary to administer
      Your Contract, which may include, but is not limited to: Your enrollment
      or application form, declarations page, Policy, certificate, terms and
      conditions, claims adjudication, notices, billing statements, retail
      installment contract, notice of cancellation, notice of non-renewal and
      changes in the terms of Your Contract. Communications also means any
      marketing offers We may send via email, text or through any other
      electronic medium allowed by law.
    </p>
    <p>
      “<strong>Contract</strong>” means a Policy/certificate, or any other
      product or service requested by You and provided by Us.&nbsp;
    </p>
    <p>
      “<strong>Policy</strong>” means a written contract of insurance, or
      written agreement effecting insurance, or the certificate thereof, and
      includes all clauses, riders or endorsements, and declarations page.&nbsp;
    </p>
    <p>
      <strong
        >Scope of Communications to Be Provided in Electronic Form.</strong
      >
      You agree that We may provide any Communication in electronic format, and
      that We may discontinue sending paper Communications to You. We reserve
      the right to modify the terms and conditions on which We provide
      electronic Communications at any time.
    </p>
    <p>
      <strong
        >Method of Providing Communications to You in Electronic Form.</strong
      >
      All Communications may be provided to You by one or more of the following
      methods: (1) via e-mail; (2) by access to a secure website that We will
      designate in advance for such purpose; (3) SMS text or iMessage (standard
      messaging rates apply) sent through an automatic telephone dialing system,
      or other means; and (4) any other electronic means of delivery permissible
      under applicable law.
    </p>
    <p>
      <strong>How to Withdraw Consent.</strong> You may withdraw Your consent to
      receive Communications electronically by contacting Us at
      <a href="mailto:rentersmail@assurant.com">rentersmail@assurant.com</a>
      Please allow a reasonable period of time to process Your request.&nbsp;
    </p>
    <p>
      <strong>How to Update Your Records.</strong> It is Your responsibility to
      provide Us with true, accurate and up-to-date contact information. You can
      update Your information by contacting Us at
      <a href="mailto:rentersmail@assurant.com">rentersmail@assurant.com</a>
      Please do not send confidential information to Us via traditional e-mail,
      as We cannot guarantee that the transmission will be secure.
    </p>
    <p>
      <strong>Hardware and Software Requirements.</strong> In order to access,
      view and retain electronic Communications from Us, You must have: (i) A
      device suitable for connecting to the Internet; (ii) An up-to-date
      Internet browser and device software; (iii) A valid e-mail account and/or
      cell phone number or account number; (iv) Added the domain[s]
      @assurant.com to Your e-mail account’s list of “safe senders;” (v)
      Electronic storage capacity to retain Our Communications and/or a printer;
      and (vi) Software that enables You to view files in Portable Document
      Format. You may be able to download the most recent version of Adobe
      Reader by <a href="http://www.adobe.com/">clicking here</a>. If You cannot
      download the most recent version of Adobe Reader, please call Your
      manufacturer to find out how to download software that is functionally
      equivalent.
    </p>
    <p>
      <strong>Requesting Paper Copies. </strong>You may request a paper copy of
      any Communication by contacting Us at
      <a href="mailto:rentersmail@assurant.com">rentersmail@assurant.com</a>.
    </p>
    <p>
      <strong>Severability. </strong>If any court of law, having the
      jurisdiction to decide on this matter, rules that any provision of this
      Disclosure is invalid, then that provision will be removed, and the
      remaining provisions will continue to be valid and enforceable.
    </p>
    <p>
      <strong>Acceptance and Consent. </strong>You acknowledge that: (i) You are
      the applicant or owner of the Contract, or are validly authorized by the
      applicant or owner to act on his/her behalf; (ii) Your consent to enter
      into the Contract and receive Communications electronically does not
      automatically expire and is not limited as to duration; (iii) We will not
      be liable for any loss, liability, cost, expense, or claim arising from
      the services provided pursuant to this Disclosure; (iv) If You cannot
      access Your Communications, You must immediately notify Us so We can help
      identify the issue, or arrange to have the Communications delivered via
      alternative means.
    </p>
  </div>
</template>
